<app-frats-charts *ngIf="!(isHandset$ | async)"></app-frats-charts>

<app-frats-table></app-frats-table>
